import React, { useState } from "react";
import PropTypes from "prop-types";
import { SkedIcon } from "ui";

const HashtagListWrapper = ({ children, defaultIsOpen, title }) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const icon = isOpen ? "icon-down-close" : "icon-left-close";
  return (
    <div>
      <div
        className="font-black ml-6 cursor-pointer flex"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="mr-4">{title}</div>
        <div>
          <SkedIcon icon={icon} />
        </div>
      </div>
      {isOpen && (
        <div>
          <div className="flex flex-grow justify-end text-gray-400 pb-2 pr-4">
            Expires:
          </div>
          <div className="mb-2">{children}</div>
        </div>
      )}
    </div>
  );
};

HashtagListWrapper.propTypes = {
  children: PropTypes.node,
  defaultIsOpen: PropTypes.bool,
  title: PropTypes.string,
};

export default HashtagListWrapper;
